import _values from 'lodash/fp/values';

import createSort from '../../../shared/table/create-sort.js';

const defaultInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'Id'
		},
		date: {
			index: 'date',
			title: 'Date',
			direction: 'desc'
		},
		title: {
			index: 'title',
			title: 'Title',
			direction: 'asc'
		},
		description: {
			index: 'description',
			title: 'Description'
		},
		price: {
			index: 'price',
			title: 'Price',
			direction: 'asc'
		},
		currency: {
			index: 'currency',
			title: 'Currency'
		},
		available_amount: {
			index: 'available_amount',
			title: 'Amount'
		},
		category: {
			index: 'categories',
			title: 'Category'
		},
		actions: {
			title: 'Actions'
		}
	},
	sortByColumn: {
		index: 'id',
		title: 'Id',
		direction: 'desc'
	}
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {
	const sort = createSort(namespace, stateNodeName, {
		type: configureSort.type,
		resolverSortFn: configureSort.resolverSortFn
	});

	const SHOW_MORE_ROWS = `${namespace}/table-show-more-rows`;

	const initialState = {
		...defaultInitialState
	};

	const actions = Object.assign({
		showMoreRows: () => ({ type: SHOW_MORE_ROWS })
	}, sort.actions);

	const reducers = Object.assign({}, sort.reducers);

	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];
			const mappedRows = rows.map(row => ({ ...row }));
			return {
				headers: _values(table.columns),
				rows: mappedRows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/bm-accounts/components/table/index.js